export const REDIR_FILE = "redirects.json";
export const ASSET_GROUPS = ["setup", "cta", "embed"];
export const NODE_TYPE = "AskAvaAsset";
export const DOC_NODE_TYPE = "AskAvaDoc";
export const PRODUCTS = ["creditTool", "tradeTool"];
export const EMBED_KEYS = ["embed-dynamic", "embed-static"];
export const siteMetadata = () => require("./site-config.json");
